module.exports = __webpack_public_path__ + "img/material.23b3c52a.svg";